import PropTypes from "prop-types";
import useUiDesignLaneRedirect from "./useUiDesignLaneRedirect";
import useUiExperimentLobbySync from "./useUiExperimentLobbySync";
import { useAuthState } from "./AuthStateContext";

export default function UiDesignLaneGuard({ actions }) {
  const { user, isAuthenticated, autoLoginInProgress } = useAuthState();
  useUiDesignLaneRedirect(user, isAuthenticated, autoLoginInProgress);
  useUiExperimentLobbySync(isAuthenticated, autoLoginInProgress, actions);
  return null;
}

UiDesignLaneGuard.propTypes = {
  actions: PropTypes.object,
};
